// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"v1_up8wNZKjCSu1m22Oc","background":"TTJ38uxQUK57hpJFT4XD","text":"eCzTU6WD3dMgElc2uR_Z"};